import * as React from 'react';
import { cn, Container, Label } from 'sg-styleguide';

import './select-box.scss';

const SelectBox = ({
  type,
  children,
  selected,
  align = 'none',
  className = '',
  label = null,
  withBorder = true,
  ...props }) => {
  const classes = cn(
    className,
    'select-box',
    align && `select-box--align-${align}`,
    selected && 'select-box--selected',
    withBorder && 'select-box--with-border'
  );

  return (
    <Container elevation="none" padding="none" className={classes} {...props}>
      {label && <Label type={type} className="ua-absolute-center-top">{label}</Label>}
      {children}
    </Container>
  );
};

export default SelectBox;
